<template>
  <div
    v-bind:class="first ? '' : 'mt-10 sm:mt-0'"
    class="text-14px md:text-14px lg:text-18px xl:text-20px shadow-2xl rounded-17px p-6 md:p-8 md:p-8 lg:p-10 card flex flex-col justify-start bg-white w-auto lg:card"
  >
    <div class="w-90px md:w-2/5 self-start">
      <img :src="icon" />
    </div>

    <p class="mt-2 font-bold font-extrabold font-Foco">{{ $t(header) }}</p>
    <p class="mt-2">
      {{ $t(text) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FeatureCard',
  data() {
    return {};
  },
  props: ['header', 'text', 'first', 'icon'],
};
</script>

<style scoped>
@media (max-width: 640px) {
  .card {
    width: 100% !important;
  }
}
</style>
